export default "__VITE_ASSET__BeLZhYpD__"